import Vue from 'vue'
import axios from 'axios'
import { Auth } from '@aws-amplify/auth'
import store from '@/store/store'
import router from '@/router'

const ORCHESTRATOR_PATH = '/ecommerce'

export const axiosPlugin = {
  install: function (VueConstructor, options) {
    const { baseUrl, urlPrefix, commonHeaders } = options

    const commonHeadersMerged = {
      ...axios.defaults.headers,
      ...commonHeaders
    }

    const errorHandler = (error) => {
      if (window.newrelic && error) {
        const responseData = error.response && error.response.data
        window.newrelic.noticeError(new Error(error.message), { responseData })
      }
      if (error.response.status === 401) {
        router.push({ name: 'logout' })
      } else {
        return Promise.reject(error)
      }
    }

    // Log if country is missing
    if (!Object.prototype.hasOwnProperty.call(commonHeadersMerged, 'country')) {
      if (window.newrelic) {
        window.newrelic.noticeError('axios.js: Missing country')
      }
    }

    const orchestratorRequestInterceptor = async (req) => {
      const currentSession = await Auth.currentSession()
      const authToken = currentSession && currentSession.idToken && currentSession.idToken.jwtToken
      req.headers.authorization = authToken ? `Bearer ${authToken}` : null
      return req
    }

    const serviceConfigs = [{
      name: '$axiosMarc',
      baseURL: `${baseUrl}${urlPrefix}/api/v2`,
      requestInterceptors: []
    }, {
      name: '$axiosOrchestrator',
      baseURL: baseUrl, // Orchestrator doesn't need the urlPrefix
      requestInterceptors: [orchestratorRequestInterceptor]
    }]

    serviceConfigs.forEach((serviceConfig) => {
      const axiosService = axios.create({
        baseURL: serviceConfig.baseURL,
        headers: {
          ...commonHeadersMerged
        }
      })
      serviceConfig.requestInterceptors.forEach((requestInterceptor) => {
        axiosService.interceptors.request.use(requestInterceptor)
      })
      axiosService.interceptors.response.use(response => response, errorHandler)
      VueConstructor.prototype[serviceConfig.name] = axiosService
    })
  }
}

export function initAxios (VueInstance = Vue, winObj = window) {
  const baseUrl = ORCHESTRATOR_PATH
  const urlPrefix = store.getters['site/urlPrefix']
  const commonHeaders = {
    site: store.getters['site/site'],
    country: store.getters['site/countryCode'],
    hostname: winObj.location.hostname
  }

  VueInstance.use(axiosPlugin, { baseUrl, urlPrefix, commonHeaders })
}
